<template>
    <div id="budget_issues" class="container-fluid">
        <router-link class="btn btn-secondary main-button ml-2 pull-right" :to="{ path: '/budget/issues/excluded/classifications'}" style="pointer-events:initial !important;">Excluded Classifications</router-link>
        <router-link class="btn btn-secondary main-button ml-2 pull-right" :to="{ path: '/budget/issues/missing/clients'}" style="pointer-events:initial !important;">Missing Clients</router-link>
        <button class="btn btn-secondary main-button reverse unclickable pull-right" style="pointer-events:initial !important;">Unclassified Campaigns</button>
        <h5 class="text-center my-3">Unclassified Campaigns</h5>
        <v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                tableData: [],
                columns: ['account_id', 'account_name', 'campaign_id', 'campaign_name'],
                options: {
                    headings: {
                        account_id: 'Account ID',
                        account_name: 'Account Name',
                        campaign_id: 'Campaign ID',
                        campaign_name: 'Campaign Name'
                    },
                    sortable: ['account_id', 'account_name', 'campaign_id', 'campaign_name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} unclassified campaigns|{count} unclassified campaigns|One unclassified campaign',
                        filter: '',
                        filterPlaceholder: 'Search ...',
                        noResults: 'No matching unclassified campaigns'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/budget/issues/unclassified/campaigns')
                ])
                .then(axios.spread((issues) => {
                    this.tableData = issues.data;
                }));
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
